import { applySeo } from "@/lib/seo-head";
import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import siteConfig from "@/config/site.json";

export const Route = createFileRoute("/privacidad")({
  component: PrivacidadPage,
  head: (ctx) => applySeo(ctx.matches, ((_c: unknown) => ({
    meta: [
      { title: `Política de Privacidad — ${siteConfig.brand.name}` },
      {
        name: "description",
        content:
          "Política de privacidad de RR Lex Juristas: tratamiento de datos personales, finalidades, derechos del usuario y contacto del responsable.",
      },
      { property: "og:title", content: `Política de Privacidad — ${siteConfig.brand.name}` },
      {
        property: "og:description",
        content:
          "Política de privacidad de RR Lex Juristas: tratamiento de datos personales, finalidades, derechos del usuario y contacto del responsable.",
      },
      { property: "og:url", content: "https://rrlexjuristas.com/privacidad" },
    ],
    links: [
      { rel: "canonical", href: "https://rrlexjuristas.com/privacidad" },
    ],
  }))(ctx)),
});

function PrivacidadPage() {
  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-6 py-20">
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">Legal</p>
        <h1 className="text-4xl md:text-5xl font-serif mb-8">Política de Privacidad</h1>
        <div className="gold-divider mb-10" />

        <div className="space-y-6 text-foreground/80 leading-relaxed">
          <p>
            En {siteConfig.brand.name} tratamos sus datos personales con el máximo
            cuidado, respetando el Reglamento (UE) 2016/679 (RGPD) y la Ley
            Orgánica 3/2018 de Protección de Datos Personales y garantía de los
            derechos digitales (LOPDGDD).
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">1. Responsable del tratamiento</h2>
          <p>
            {siteConfig.brand.name} es el responsable del tratamiento de los datos
            personales facilitados a través de este sitio web o por los canales
            de contacto publicados.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">2. Finalidades</h2>
          <p>
            Sus datos serán tratados para atender consultas, gestionar citas y
            prestar los servicios jurídicos solicitados, así como para cumplir
            obligaciones legales.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">3. Legitimación</h2>
          <p>
            La base legal del tratamiento es el consentimiento del interesado,
            la ejecución de un contrato o el cumplimiento de obligaciones
            legales aplicables al ejercicio de la abogacía.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">4. Conservación</h2>
          <p>
            Los datos se conservarán durante el tiempo necesario para cumplir
            con la finalidad para la que fueron recabados y para determinar las
            posibles responsabilidades derivadas.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">5. Derechos</h2>
          <p>
            Puede ejercer sus derechos de acceso, rectificación, supresión,
            oposición, limitación y portabilidad escribiendo a{" "}
            <a className="text-gold hover:underline" href={`mailto:${siteConfig.contact.emails[0].address}`}>
              {siteConfig.contact.emails[0].address}
            </a>
            . También puede presentar una reclamación ante la Agencia Española
            de Protección de Datos.
          </p>

          <h2 className="font-serif text-2xl text-foreground mt-10">
            6. Prestadores de servicios y encargados del tratamiento
          </h2>
          <p>
            {siteConfig.brand.name} utiliza proveedores tecnológicos para la
            prestación de sus servicios y la gestión de su sitio web y sistemas
            de comunicación.
          </p>
          <p>
            Entre dichos proveedores se encuentra <strong>PULSO33</strong>, que
            proporciona la plataforma tecnológica AgentE, el alojamiento de
            determinados servicios, el envío de comunicaciones transaccionales
            y el soporte técnico necesario para la gestión de solicitudes,
            citas y comunicaciones realizadas a través del sitio web.
          </p>
          <p>
            PULSO33 actúa exclusivamente como encargado del tratamiento y
            procesa los datos personales siguiendo las instrucciones de{" "}
            {siteConfig.brand.name} y de acuerdo con la normativa aplicable en
            materia de protección de datos. PULSO33 no utilizará los datos
            personales para fines comerciales propios ni los comunicará a
            terceros salvo obligación legal o autorización expresa del
            responsable del tratamiento.
          </p>
        </div>
      </article>
    </Layout>
  );
}
